import { cloneElement, FC, ReactElement } from 'react'

import * as AvatarPrimitive from '@radix-ui/react-avatar'

import { avatarVariants } from '../styles'
import { AvatarContentProps, AvatarProps } from '../types'

export const AvatarRoot: FC<AvatarProps> = (props): ReactElement => {
  const { children, mode = 'SQUARE', size, classNameContainer, classNameRoot, onClick } = props

  const { container } = avatarVariants({ mode, size })

  return (
    <AvatarPrimitive.Root className={classNameRoot}>
      {onClick ? (
        <button type="button" onClick={onClick} className={container({ className: classNameContainer })}>
          {cloneElement(children as ReactElement<AvatarContentProps>, { mode, size })}
        </button>
      ) : (
        <div
          className={container({
            className: classNameContainer ? `${classNameContainer} cursor-default` : 'cursor-default',
          })}
        >
          {cloneElement(children as ReactElement<AvatarContentProps>, { mode, size })}
        </div>
      )}
    </AvatarPrimitive.Root>
  )
}

AvatarRoot.displayName = 'Avatar.Root'
